{
  "nav": "Sources",
  "title": "Sources",
  "description": "État de chaque source de données. Une source interrogée est signalée en retard sans succès depuis trois intervalles.",
  "loading": "Chargement des sources…",
  "error": "Impossible de charger les sources.",
  "empty": "Aucune source configurée.",
  "columns": {
    "name": "Source",
    "status": "État",
    "lastSuccess": "Dernier succès",
    "lastError": "Dernière erreur",
    "items": "Reçus (24 h)",
    "actions": "Actions"
  },
  "mode": {
    "poll": "interrogée toutes les {{interval}}",
    "webhook": "webhook",
    "stream": "flux"
  },
  "status": {
    "active": "Active",
    "degraded": "Dégradée",
    "paused": "En pause",
    "error": "En erreur"
  },
  "stale": "En retard",
  "never": "Jamais",
  "none": "Aucune",
  "items": "{{events}} évén. · {{metrics}} mesures",
  "pause": "Mettre en pause",
  "resume": "Reprendre",
  "pauseLabel": "Mettre en pause {{name}}",
  "resumeLabel": "Reprendre {{name}}",
  "test": "Tester",
  "testLabel": "Tester {{name}}",
  "testing": "Test en cours…",
  "testOk": "Test réussi en {{ms}} ms : {{events}} événement(s), {{metrics}} mesure(s). Rien n’a été enregistré.",
  "testFailed": "Échec du test : {{error}}",
  "testWebhook": "Une source webhook ne peut pas être testée d’ici : elle attend que l’expéditeur parle.",
  "actionFailed": "L’action a échoué.",
  "new": "Nouvelle source",
  "edit": "Modifier",
  "editLabel": "Modifier {{name}}",
  "dialog": {
    "titleNew": "Nouvelle source",
    "titleEdit": "Modifier {{name}}",
    "description": "Une source relie VISION360 à un service. Ses réglages dépendent du connecteur.",
    "close": "Fermer",
    "connector": "Connecteur",
    "connectorPlaceholder": "Choisir un connecteur",
    "connectorOption": "{{name}} ({{mode}})",
    "modes": {
      "poll": "interrogée",
      "webhook": "webhook",
      "stream": "flux"
    },
    "connectorsLoading": "Chargement des connecteurs…",
    "connectorsError": "Impossible de charger les connecteurs.",
    "connectorUnknown": "Le connecteur « {{id}} » n’est plus disponible : ses réglages s’éditent en JSON brut.",
    "name": "Nom",
    "pollInterval": "Intervalle d’interrogation (secondes)",
    "pollIntervalHint": "De {{min}} s à 24 h. Vide : {{fallback}} s.",
    "config": "Réglages",
    "secrets": "Secrets",
    "secretsHintNew": "Chiffrés à l’enregistrement et jamais réaffichés.",
    "secretsHintEdit": "Laissez vide pour garder le secret actuel ; un secret saisi remplace seulement celui-là.",
    "cancel": "Annuler",
    "create": "Créer la source",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "invalid": "Corrigez les champs signalés.",
    "saveFailed": "L’enregistrement a échoué.",
    "rejected": "Refusé : {{message}}",
    "errors": {
      "connectorId": "Choisissez un connecteur.",
      "name": "Donnez un nom de 120 caractères au plus.",
      "pollIntervalS": "Entre 10 et 86 400 secondes."
    },
    "webhook": {
      "title": "Source créée",
      "intro": "Configurez l’expéditeur avec cette adresse et ce secret. Le secret ne sera plus jamais affiché : copiez-le maintenant.",
      "url": "Adresse du webhook",
      "secret": "Secret",
      "copy": "Copier",
      "copyLabel": "Copier : {{what}}",
      "copied": "Copié.",
      "copyFailed": "Copie impossible : sélectionnez le texte à la main.",
      "done": "Terminé"
    }
  },
  "form": {
    "optional": "facultatif",
    "add": "Ajouter",
    "addLabel": "Ajouter un élément à {{field}}",
    "item": "Élément {{index}}",
    "itemOf": "{{field}}, élément {{index}}",
    "removeItem": "Retirer l’élément {{index}} de {{field}}",
    "none": "Aucun élément.",
    "range": "De {{min}} à {{max}}.",
    "min": "Au moins {{min}}.",
    "max": "Au plus {{max}}.",
    "count": "{{count}} sur {{max}}",
    "jsonHint": "Ce réglage s’édite en JSON brut.",
    "jsonInvalid": "JSON invalide."
  },
  "lookup": {
    "placeholder": "Rechercher…",
    "searching": "Recherche…",
    "empty": "Aucun résultat",
    "error": "Recherche impossible : le connecteur ne répond pas.",
    "remove": "Retirer {{label}}",
    "full": "Maximum atteint ({{max}}). Retirez-en un pour en ajouter un autre."
  },
  "config": {
    "accountKey": "Clé de compte",
    "agendaHour": "Heure de l’agenda du jour",
    "backfillS": "Rattrapage au démarrage (secondes)",
    "bucket": "Bucket",
    "category": "Catégorie",
    "conflictHours": "Horizon des conflits (heures)",
    "erpUrl": "Adresse de l’ERP",
    "feeds": "Flux",
    "forecastHour": "Heure de la prévision",
    "id": "Identifiant",
    "instanceUrl": "Adresse de l’instance",
    "label": "Libellé",
    "latitude": "Latitude",
    "lines": "Lignes",
    "longitude": "Longitude",
    "maxItemsPerFeed": "Articles par flux",
    "name": "Nom affiché",
    "nuts3": "Code de zone (NUTS 3)",
    "org": "Organisation",
    "places": "Lieux",
    "publicUrl": "Adresse publique",
    "reportSuccessfulRuns": "Signaler aussi les exécutions réussies",
    "repositories": "Dépôts (propriétaire/nom)",
    "soonMinutes": "Rappel avant un événement (minutes)",
    "stops": "Arrêts",
    "url": "Adresse",
    "vigilance": "Vigilance météo",
    "webUrl": "Adresse de l’interface web"
  },
  "secretNames": {
    "apiKey": "Clé d’API",
    "password": "Mot de passe",
    "token": "Jeton",
    "url": "Adresse privée",
    "username": "Identifiant"
  }
}
